export default {
  CATEGORY: 'FO API',
  ACTION: 'Error',

  NO_ACTIVE_CONNECTION: 'FRONTOFFICE UNAVAILABLE',
  BAD_GATEWAY: 'BAD GATEWAY',
  NO_API_CONNECTION: 'API UNAVAILABLE',
  UNAUTHORIZED: 'UNAUTHORIZED',
  TOKEN_REVOKED: 'TOKEN_REVOKED',
  MIDDLEWARE_ERROR: 'MIDDLEWARE_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
}
